import * as go from 'gojs';
import { FIXED_POSITION_PROP } from './../config/common-prop-names';

export const alignNodesInGroupAPI = (group: go.Node) => {
  if (!group?.diagram || !(group instanceof go.Group) || !group?.layout) {
    return;
  }

  group.memberParts.each((n) => group.diagram!.model.set(n.data, FIXED_POSITION_PROP, false));

  const prevOngoing = group.layout.isOngoing;
  group.layout.isOngoing = true;
  group.layout.invalidateLayout();
  group.layout.isOngoing = prevOngoing;
};
